import { Injectable } from '@angular/core';
import { Building, BuildingOpeningDay, BuildingOpeningHour, RoomBooking } from '../models';

export interface DayLimits {
  afternoon: BuildingOpeningHour;
  morning: BuildingOpeningHour;
}

@Injectable()
export class OpeningDaysAndHoursService {
  private periodAm = 'AM';
  private periodPm = 'PM';

  /**
   * return the limits of the building for the precise date passed
   *
   * @param building
   * @param date
   */
  getBuildingDayLimits(building: Building, date: Date): DayLimits {
    const openingDays = building.openingDays as BuildingOpeningDay[];
    const openingDay = openingDays.find(day => (day.day === date.getDay()) || (day.day === 7 && date.getDay() === 0));

    const openingHours = openingDay.openingHours as BuildingOpeningHour[];
    return {
      morning: openingHours[0].period === this.periodAm ? openingHours[0] : openingHours[1],
      afternoon: openingHours[0].period === this.periodPm ? openingHours[0] : openingHours[1],
    };
  }

  mergeOpeningDaysAndHours(
    openingDays: BuildingOpeningDay[],
    openingHours: BuildingOpeningHour[],
  ): BuildingOpeningDay[] {
    return openingDays.map(openingDay => {
      openingDay.openingHours = openingHours
        .filter(openingHour => openingDay.openingHours.includes(openingHour['@id']));
      return openingDay;
    });
  }

  /**
   * true if room booking take place in the period limits, otherwise return false
   *
   * @param roomBooking
   * @param dayLimits
   * @param period must be 'AM' or 'PM'
   */
  roomBookingTakesPlaceInPeriod(roomBooking: RoomBooking, dayLimits: DayLimits, period: string): boolean {
    let periodStart: Date;
    let isTakingPlace = false;

    const limitToCompare: Date = new Date();
    const endDate = new Date(roomBooking.endDate);

    if (period === this.periodAm) {
      const morningEndToCompare = new Date();
      const periodEnd = new Date(dayLimits.morning.periodEnd);
      const startDate = new Date(roomBooking.startDate);
      morningEndToCompare.setHours(periodEnd.getHours(), periodEnd.getMinutes(), 0);
      periodStart = new Date(dayLimits.morning.periodStart);
      limitToCompare.setHours(periodStart.getHours(), periodStart.getMinutes(), 0);

      isTakingPlace = startDate <= morningEndToCompare && endDate > limitToCompare;
    }
    if (period === this.periodPm) {
      periodStart = new Date(dayLimits.afternoon.periodStart);
      limitToCompare.setHours(periodStart.getHours(), periodStart.getMinutes(), 0);

      isTakingPlace = endDate > limitToCompare;
    }

    return isTakingPlace;
  }
}
